import React, { useContext, useState, useRef } from 'react'
import axios from 'axios'
import { AuthContext } from '../context/AuthContext'
import { useNavigate, Link } from 'react-router-dom'
import '../styles/SignIn.css'
import config from '../config'
import useResponsiveWidth from '../hooks/useResponsiveWidth'


const SignIn = () => {
  var navigate = useNavigate();
  useResponsiveWidth();
  const [email, setEmail] = useState('');

  const submitForgotPinForm = async (e) => {
    e.preventDefault()
    try {
      const response = await axios.post(
        `${config.backendUrl}/api/auth/request-otp-email`,
        {
          email,
        }
      )
      if (response.data.status) {
        localStorage.setItem('vestr_fg_token', response.data.data.token);
        navigate('/reset-pin');
      }
      else {
        console.log('Error');
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error)
      // alert('Error signing in')
    }
  }


  return (
    <div className="signin-container">
      <h1 className="si-main-header">Invest with the best.</h1>
      <div className="si-main-content">
        <div className="si-intro-text">
          <h2>The Vestr Vision</h2>
          <p style={{ paddingTop: '3rem' }}>
            We envision a <b>finance super app</b> complete with
            leaderboards, live trading, sim trading, feed, news, rooms, copy
            trading, subscriptions, professional research, trading AI and
            more. We want to be the <b>home for the retail revolution</b>,
            where users can find experts and experts find their audience.
          </p>
          <p>
            Also check out{' '}
            <a
              className="si-link bold"
              href="https://vestrdata.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              vestrdata.com
            </a>
            !
          </p>
        </div>
        <div className="si-auth-content">
          <div className="SignNavItems">
            <button className="SignNavButton bold SignNavButtonActive"><span className="si-btn-txt bold">Forgot PIN</span></button>
          </div>

          <div className="si-auth-form-wrapper" style={{textAlign:"center"}}>
            <form className="si-auth-form" onSubmit={submitForgotPinForm}>
              <input type="email" placeholder="Email Address" required defaultValue onChange={(e) => setEmail(e.target.value)} value={email} />
              <button type="submit" className="CreatePostFeedButton greenButton moreButtonPadding si-form-btn">Send OTP</button>
              <Link to="/signin" className="si-link bold" style={{fontSize:"14px"}}>Sign In</Link>
            </form>
          </div>


        </div>
      </div>
    </div>
  )
}

export default SignIn
